import { Subscription } from 'rxjs';
// Angular
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
// Layout
import { LayoutConfigService, SplashScreenService } from './core/_base/layout';
// Layout
import { TranslationService } from './core/_base/layout';
// language list
import { locale as esLang } from './core/_config/i18n/es';
import { StylesService } from './core/_base/layout/services/styles.service';


@Component({
	// tslint:disable-next-line:component-selector
	selector: 'body[kt-root]',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit, OnDestroy {
	// Public properties
	title = 'Metronic';
	loader: boolean;
	private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/

	/**
	 * Component constructor
	 *
	 * @param translationService: TranslationService
	 * @param router: Router
	 * @param layoutConfigService: LayoutCongifService
	 * @param splashScreenService: SplashScreenService
	 * @param stylesService
	 * @param cdr
	 */
	constructor(private translationService: TranslationService,
				private router: Router,
				private layoutConfigService: LayoutConfigService,
				private splashScreenService: SplashScreenService,
				private stylesService: StylesService,
				private cdr: ChangeDetectorRef) {

		// register translations
		this.translationService.loadTranslations(esLang);
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit(): void {
		// enable/disable loader
		this.loader = this.layoutConfigService.getConfig('loader.enabled');

		const routerSubscription = this.router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				// hide splash screen
				this.splashScreenService.hide();

				// scroll to top on every route change
				window.scrollTo(0, 0);
			}
		});
		this.unsubscribe.push(routerSubscription);

		this.stylesService.getConfigStyles().then(
			(config) => {
				this.splashScreenService.hide();
				let style = document.createElement('style');
				style.innerHTML = ' .mat-tab-group.mat-primary .mat-ink-bar, .mat-tab-nav-bar.mat-primary .mat-ink-bar{ background: ' + config.primaryColor + '!important;}'
					+ '.mat-fab.mat-primary,.mat-flat-button.mat-primary,.mat-mini-fab.mat-primary,.mat-raised-button.mat-primary{background: '+ config.primaryColor+ ' !important;}'
					+ '.mat-chip.mat-standard-chip.mat-chip-selected.mat-primary{background: '+ config.primaryColor+ ' !important;color:#fff !important}'
					+ '.mat-toolbar.mat-primary{background: '+ config.primaryColor+ ' !important;color:#fff !important}'
					+ '.btn.btn-label-primary{color: '+ config.primaryColor+ ' !important;}'
					+ '.gigot-color-text{color: '+ config.primaryColor+ ' !important;}'
					+ '.gigot-color-bg{background: '+ config.primaryColor+ ' !important; border:'+ config.primaryColor+ ' !important; }'
					+ '.mat-button.mat-primary.mat-icon-button.mat-primary.mat-stroked-button.mat-primary{color: '+ config.primaryColor  +'!important}'
					+ '.mat-fab.mat-primary.mat-flat-button.mat-primary.mat-mini-fab.mat-primary.mat-raised-button.mat-primary{color: '+ config.primaryColor  +'!important}'
					+ '.kt-header__brand-nav button:hover{ background: ' + config.primaryColor + '!important; }'
					+ '.btn-primary{background: '+ config.primaryColor+ ' !important;color:#fff !important; border-color: ' + config.primaryColor + '!important}'
					+ '.kt-nav__item:hover span{ color: ' + config.primaryColor + '!important; }'
					+ '.mat-form-field-ripple{background-color:' + config.primaryColor + ' !important;} '
					+ '.mat-focused .mat-form-field-label{color:' + config.primaryColor + ' !important;} '
					+ '.mat-progress-spinner circle, .mat-spinner circle {stroke:' + config.primaryColor +' !important;}'
					+ '.btn-outline-gigot{color:'+ config.primaryColor +  '!important; background: transparent; border-color:'+ config.primaryColor+ ' !important;}'
					+ '.btn-outline-gigot:hover{color:#fff !important;background-color:' + config.primaryColor + ' !important;border-color:' + config.primaryColor + ' !important; cursor: pointer;}'
					+ '.btn-outline-gigot-secondary{color:'+ config.secondaryColor +  '!important; background: transparent; border-color:'+ config.secondaryColor+ ' !important;}'
					+ '.btn-outline-gigot-secondary:hover{color:#fff !important;background-color:' + config.secondaryColor + ' !important;border-color:' + config.secondaryColor + ' !important; cursor: pointer;}'
					+ '.btn-gigot-color-secondary{color:'+ config.secondaryColor + '!important;}'
					+ '.kt-header__brand-logo-default{width:110px} '
					+ '.kt-scrolltop{background: '+ config.primaryColor+ ' !important;}'
					+ '.kt-header__brand-logo-sticky{width:110px} '
					+ '.mat-fab.mat-accent[disabled], .mat-fab.mat-primary[disabled], .mat-fab.mat-warn[disabled], .mat-fab[disabled][disabled], .mat-flat-button.mat-accent[disabled], .mat-flat-button.mat-primary[disabled], .mat-flat-button.mat-warn[disabled], .mat-flat-button[disabled][disabled], .mat-mini-fab.mat-accent[disabled], .mat-mini-fab.mat-primary[disabled], .mat-mini-fab.mat-warn[disabled], .mat-mini-fab[disabled][disabled], .mat-raised-button.mat-accent[disabled], .mat-raised-button.mat-primary[disabled], .mat-raised-button.mat-warn[disabled], .mat-raised-button[disabled][disabled]{color:rgba(255, 255, 255, 0.75) !important}'
					+ '.gigot-bg-login { background-image: url('+ config.loginBackground + ') }';

					
				document.getElementsByTagName('head')[0].appendChild(style);
				this.cdr.detectChanges();
			}
		);

	}

	/**
	 * On Destroy
	 */
	ngOnDestroy() {
		this.unsubscribe.forEach(sb => sb.unsubscribe());
	}
}
